import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/SistemaContraIncendiosNormalizados/VerticalEnLinea/VerticalEnLinea1.png';

const VerticalEnLinea = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Sistema Contra Incendios- Vertical en Linea</h2>
      <div className="row align-items-start mb-2">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-10">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="Bomba 1" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas contra incendio vertical en línea son una opción eficiente y confiable para sistemas 
            de protección contra incendios. Estas bombas están diseñadas para ofrecer un rendimiento 
            excepcional en espacios reducidos y son adecuadas para diversas aplicaciones.
          </p>
          <p className="lead text-justify">
            La estructura vertical en línea permite una instalación eficiente en tuberías ya 
            existentes sin necesidad de grandes modificaciones. Su diseño vertical optimiza el uso 
            del espacio, lo que es ideal para instalaciones donde el espacio es limitado. La 
            configuración en línea reduce la necesidad de mantenimiento y mejora la fiabilidad del 
            sistema hidráulico
          </p>
        </div>
      </div>
    </div>
  );
};

export default VerticalEnLinea;
